var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toaster',{on:{"close-toaster":_vm.closeSummaryToaster},scopedSlots:_vm._u([{key:"text",fn:function(){return [(_vm.oneTime)?_c('span',[_vm._v("המערכת לא תעדכן את הצפי בחודשים הבאים")]):_c('span',[_vm._v("המערכת עדכנה את "),_c('span',{staticClass:"bold"},[_vm._v("הצפי של "+_vm._s(_vm.balanceAmountString))])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }